import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { MapPin, Wrench } from 'lucide-react';

/** Sezione destinazione: punto vendita, sede legale, impianto di riferimento. */
export const DestinazioneSection = ({ selectedCliente, puntiVendita, impianti, destinazione, onDestinazione, onAppendImpianto }) => {
  const usaSedeLegale = () => {
    const ind = selectedCliente.indirizzo_legale || '';
    const citta = selectedCliente.citta_legale || '';
    const cap = selectedCliente.cap_legale || '';
    const prov = selectedCliente.provincia_legale || '';
    onDestinazione(`${selectedCliente.ragione_sociale} - ${ind}${citta ? ', ' + citta : ''}${cap ? ' ' + cap : ''}${prov ? ' (' + prov + ')' : ''}`.trim());
  };

  return (
    <div>
      <Label className="text-xs font-mono uppercase flex items-center gap-1">
        <MapPin className="h-3 w-3" />
        Indirizzo di destinazione / Punto Vendita
      </Label>
      <div className="flex flex-col sm:flex-row gap-2">
        {puntiVendita.length > 0 && (
          <Select
            value="_placeholder"
            onValueChange={(v) => {
              if (v !== '_placeholder') onDestinazione(v);
            }}
          >
            <SelectTrigger className="rounded-md sm:w-72" data-testid="documento-destinazione-select">
              <SelectValue placeholder={`Scegli punto vendita (${puntiVendita.length})`} />
            </SelectTrigger>
            <SelectContent className="rounded-md max-h-72">
              <SelectItem value="_placeholder" disabled>Scegli punto vendita...</SelectItem>
              {puntiVendita.map((pv) => (
                <SelectItem key={`pv-${pv.id}`} value={`${pv.nome} - ${pv.indirizzo || ''}${pv.citta ? ', ' + pv.citta : ''}${pv.cap ? ' ' + pv.cap : ''}${pv.provincia ? ' (' + pv.provincia + ')' : ''}`.trim().replace(/\s-\s*$/, '')}>
                  <div className="flex flex-col">
                    <span className="font-medium">{pv.nome}</span>
                    <span className="text-[10px] text-muted-foreground">{pv.indirizzo}{pv.citta ? `, ${pv.citta}` : ''}</span>
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
        <Button
          type="button"
          variant="outline"
          className="rounded-md text-xs h-9 px-3"
          onClick={usaSedeLegale}
          title="Usa l'indirizzo della sede legale"
          data-testid="documento-destinazione-sede-btn"
        >
          <MapPin className="h-3 w-3 mr-1" />
          Sede legale
        </Button>
        <Input
          value={destinazione}
          onChange={(e) => onDestinazione(e.target.value)}
          className="rounded-md flex-1"
          placeholder="Oppure scrivi indirizzo manualmente..."
          data-testid="documento-destinazione"
        />
      </div>
      {impianti.length > 0 && (
        <div className="mt-2">
          <Label className="text-[10px] font-mono uppercase text-muted-foreground flex items-center gap-1">
            <Wrench className="h-2.5 w-2.5" />
            Impianto di riferimento (opzionale - dettaglio tecnico)
          </Label>
          <Select
            value="_placeholder"
            onValueChange={(v) => {
              if (v !== '_placeholder') onAppendImpianto(v);
            }}
          >
            <SelectTrigger className="rounded-md w-full md:w-96 h-8 text-xs mt-1" data-testid="documento-impianto-select">
              <SelectValue placeholder="Aggiungi impianto di riferimento alla destinazione..." />
            </SelectTrigger>
            <SelectContent className="rounded-md max-h-72">
              {impianti.map((imp) => {
                const label = `${imp.tipo}${imp.marca ? ' ' + imp.marca : ''}${imp.modello ? ' ' + imp.modello : ''} - Matr. ${imp.matricola}${imp.zona ? ' (' + imp.zona + ')' : ''}`;
                return (
                  <SelectItem key={`imp-${imp.id}`} value={label}>
                    <span className="text-emerald-600 font-mono text-[9px] mr-1">IMP</span>
                    {imp.tipo} {imp.modello || ''} {imp.matricola ? `· ${imp.matricola}` : ''}
                  </SelectItem>
                );
              })}
            </SelectContent>
          </Select>
        </div>
      )}
      <p className="text-[10px] text-muted-foreground mt-1">L&apos;indirizzo apparira nel PDF come Destinazione</p>
    </div>
  );
};
